var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fas', 'bars']}}),_vm._v("\n        "+_vm._s(_vm.$t('global.modules.serviceSubCategory'))+"\n    ")],1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }